// extracted by mini-css-extract-plugin
module.exports = {"quickShopLink":"Nz-z","button":"Oz-z","disabled":"Pz-z"};